'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".CustomComponent-module_iframe__GFzkA{background-color:transparent;border:0;display:none;margin:0;padding:0;width:100%}";
var styles = {"iframe":"CustomComponent-module_iframe__GFzkA"};
styleInject["default"](css_248z, 'e907e730-1da4-4744-8692-6f0cce882602');

exports["default"] = styles;
